import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { SortEnum, TimeslotStatusEnum } from '@sport-activities/sdk';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ActivityService } from '~/core/services/activity/activity.service';

export const OrganizerSharedUpcomingTimeslotsResolver: ResolveFn<unknown> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  activityService: ActivityService = inject(ActivityService)
): Observable<unknown> => {
  const timeslotId = route.paramMap.get('id');
  const [activityId] = timeslotId.split('-');

  return forkJoin([
    activityService.getActivity(activityId),
    activityService.getAllActivityTimeslots(activityId, {
      timeslotStatus: 'PUBLISHED' as TimeslotStatusEnum,
      sort: {
        order: 'asc' as SortEnum,
        by: 'startDate',
      },
    }),
  ]).pipe(
    map(([activity, timeslots]) => {
      const currentTimeslot = timeslots.find(
        (timeslot) => timeslot.identifier === timeslotId
      );

      const upcomingTimeslots = timeslots.filter(
        (timeslot) =>
          new Date(timeslot.startDate) >= new Date(currentTimeslot.startDate)
      );

      return {
        activity,
        upcomingTimeslots,
      };
    })
  );
};
